'use strict';

export const SET_LIST = 'locationList/SET_LIST';
export const SELECT_ALL = 'locationList/SELECT_ALL';
export const UNSELECT_ALL = 'locationList/UNSELECT_ALL';
export const TOGGLE_SELECT = 'locationList/TOGGLE_SELECT';
export const REORDER_ASSIGNED = 'locationList/REORDER_ASSIGNED';
export const MOVE_SELECTION = 'locationList/MOVE_SELECTION';
export const POST_REVERSE_SELECTION = 'locationList/POST_REVERSE_SELECTION';
export const POST_REVERSE_SELECTION_COMPLETED = 'locationList/POST_REVERSE_SELECTION_COMPLETED';
export const POST_OPTIMIZE_ROUTE = 'locationList/POST_OPTIMIZE_ROUTE';
export const POST_OPTIMIZE_ROUTE_COMPLETED = 'locationList/POST_OPTIMIZE_ROUTE_COMPLETED';
export const POST_FLAG_INCREMENT = 'locationList/POST_FLAG_INCREMENT';
export const POST_FLAG_INCREMENT_COMPLETED = 'locationList/POST_FLAG_INCREMENT_COMPLETED';
export const POST_PRIORITY_INCREMENT = 'locationList/POST_PRIORITY_INCREMENT';
export const POST_PRIORITY_INCREMENT_COMPLETED = 'locationList/POST_PRIORITY_INCREMENT_COMPLETED';
export const POST_DELETE_LOCATIONS = 'locationList/POST_DELETE_LOCATIONS';
export const POST_DELETE_LOCATIONS_COMPLETED = 'locationList/POST_DELETE_LOCATIONS_COMPLETED';
export const POST_ASSIGN_NEXT_DAY = 'locationList/POST_ASSIGN_NEXT_DAY';
export const POST_ASSIGN_NEXT_DAY_COMPLETED = 'locationList/POST_ASSIGN_NEXT_DAY_COMPLETED';
export const POST_REORDERED_LOCATIONS = 'locationList/POST_REORDERED_LOCATIONS';
export const POST_REORDERED_LOCATIONS_COMPLETED = 'locationList/POST_REORDERED_LOCATIONS_COMPLETED';
export const POST_CACHE_ROUTES = 'locationList/POST_CACHE_ROUTES';
export const POST_ADD_TO_ROUTE = 'locationList/POST_ADD_TO_ROUTE';
export const POST_ADD_TO_ROUTE_COMPLETED = 'locationList/POST_ADD_TO_ROUTE_COMPLETED';
